/* eslint-disable */

import { mapState, mapMutations, mapGetters } from 'vuex'
import { api } from "../request/api.js"

import { init } from '@airwallex/components-sdk';
const { payments } = await init({
  env: 'prod', // Choose the Airwallex environment ('demo' or 'prod')
  enabledElements: ['payments'],
});


export default {

  data() {
    return {

      roleList: [],
      serverList: [],
      selectedRole: '',
      dropdownVisible: false,
      showTanchuang: false,
      showExitConfirm: false,
      showLoginDialog: false,
      showXianjinshuoming: false,
     
      zuanshiList: [],
      xianjinList: [],
      banners: [
        // require('../assets/banner3.png'),
        //require('../assets/banner2.png'),
        require('../assets/banner1.png'),
      ],
      currentBanner: 0,
      bannerInterval: null,
      loginAccount: '',
      loginPassword: '',
      loginAgree: false,
      showLoginError: false,
      loginErrorType: '', // 'fail' | 'id' | 'pwd'
      loginErrorTimer: null,
      showConfirmDialog: false,
      ageDropdownVisible: false,
      selectedAge: 0,
      ageOptions: [
        '18歳以上（上限なし）',
        '16～17歳（1ヶ月20,000円まで）',
        '~15歳（1ヶ月5000円まで）'
      ],
      ageShortOptions: ['18歳以上（上限なし）', '16～17歳（1ヶ月20,000円まで）', '~15歳（1ヶ月5000円まで）'],
      dropdownListVisible: false,

      selGameIndex: -1,
      isLogining: false,
      isPaying: false,
      showRoles: false,
      showServers: false,
      selObj: {
        gameIndex: -1,
        serverIndex: -1,
        roleIndex: -1,
        productIndex: -1,
        productType: -1,
        paymentIndex: 0,
      },
      loading: false,
      productList: [],
      thirdLogin: {
        google: false,
        apple: false,
        fb: false
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'gameInfo', 'games']),
    hasLogin() {
      return this.isLogined()
    },
    serverName() {
      return this._getServer() && this._getServer().name || 'サーバーを選んでください'
    },
    roleName() {
      return this._getRole() && this._getRole().name || 'キャラを選択してください'
    },
    payProductName() {
      var p = this.getCurrentProduct()
      if (!p) return ''

      if (p.type == 1) {
        return '有料ダイヤ' + p.diamond + '個'
      }
      if (p.type == 2) {
        if (p.sub_type == 0) return p.voucher + '金券'

        return p.voucher + ' + ' + p.b_diamond
      }
      return ''
    },
    payRebateName() {
      var p = this.getCurrentProduct()
      if (!p) return ''

      if (p.type == 1) return '有料ダイヤ' + p.b_diamond + '個'

      if (p.sub_type == 0) return '有料ダイヤ' + p.b_diamond + '個'

      return p.b_diamond + p.voucher
    },
    payPrice() {
      var p = this.getCurrentProduct()
      if (!p) return '0'

      return p.price
    },
    payPaymentIcon() {
      var p = this.gameInfo.payments[this.selObj.paymentIndex].key || ''
      return require(`../assets/pay/tip/${p}-tip.png`)
    },
    payPaymentName() {
      return this.gameInfo.payments[this.selObj.paymentIndex].name || ''
    },
    showXianjinNew() {
      var p = this.getCurrentProduct()
      if (!p) return false
      return p.sub_type == 1
    }

  },
  methods: {
    ...mapMutations(['loginLocal', 'setGameInfo','logout']),
    getPaymentImg(index, payMethod) {
      const suffix = this.selObj.paymentIndex == index ? '-sel' : ''
      // 图片命名：creditsel.png 或 creditunsel.png
      // var payMethod = this.gameInfo.payments[index].payMethod || ''
      return require(`../assets/pay/${payMethod}${suffix}.png`)
    },
    selPayment(index) {
      if (this.selObj.paymentIndex == index) return
      this.selObj.paymentIndex = index
      if (this.isGashLimitPayment()) {
        for(var i of this.zuanshiList) {
          i.show = i.price < 200000
          i.sel = false
        }
        for(var i of this.xianjinList) {
          i.show = i.price < 200000
          i.sel = false
        }
        this.selObj.productType = -1
        this.selObj.productIndex = -1
      }else{
        for(var i of this.zuanshiList) {
          i.show = true
        }
        for(var i of this.xianjinList) {
          i.show = true
        }
      }
    },
    selProduct(item, i) {
      for (let index = 0; index < this.zuanshiList.length; index++) {
        const element = this.zuanshiList[index];
        element.sel = item.type == element.type && index == i
      }
      for (let index = 0; index < this.xianjinList.length; index++) {
        const element = this.xianjinList[index];
        element.sel = item.type == element.type && index == i
      }
      this.selObj.productType = item.type
      this.selObj.productIndex = i
    },
    nextBanner() {
      this.currentBanner = (this.currentBanner + 1) % this.banners.length;
    },
    setBanner(idx) {
      this.currentBanner = idx;
    },
    toggleTanchuang() {
      this.showTanchuang = !this.showTanchuang;
      if (this.showTanchuang) {
        document.addEventListener('click', this.handleOutsideClick);
      } else {
        document.removeEventListener('click', this.handleOutsideClick);
      }
    },
    handleOutsideClick() {
      this.showTanchuang = false;
      document.removeEventListener('click', this.handleOutsideClick);
    },
    logout2() {
      this.logout()
      this.showExitConfirm = false;
      this.showTanchuang = false;
    },
    showError(type) {
      this.loginErrorType = type;
      this.showLoginError = true;
      if (this.loginErrorTimer) clearTimeout(this.loginErrorTimer);
      this.loginErrorTimer = setTimeout(() => {
        this.showLoginError = false;
      }, 3000);
    },
    openConfirmDialog() {
      this.showConfirmDialog = true;
    },
    closeConfirmDialog() {
      this.showConfirmDialog = false;
      this.ageDropdownVisible = false;
    },
    toggleAgeDropdown() {
      this.ageDropdownVisible = !this.ageDropdownVisible;
      if (!this.ageDropdownVisible) {
        this.dropdownListVisible = false;
      }
    },
    toggleDropdownList(e) {
      e.stopPropagation();
      this.dropdownListVisible = !this.dropdownListVisible;
    },
    selectAge(idx) {
      this.selectedAge = idx;
      this.dropdownListVisible = false;
    },
    getPayTypeName(filename) {
      return filename.replace('.png', '');
    },
    preventZoom(e) {
      if ((e.ctrlKey || e.metaKey)) {
        e.preventDefault();
      }
    },
    showLoading() {
      this.loading = true
    },
    hideLoading() {
      this.loading = false
    },
    getCurrentProduct() {
      switch(this.selObj.productType) {
        case 1:
          return this.zuanshiList[this.selObj.productIndex]
        case 2:
          return this.xianjinList[this.selObj.productIndex]
      }
      return false
    },
    isAirwallex() {
      return this.getCurrentPaymethod().indexOf('airwallex') >= 0
    },
    isAdyen() {
      return this.getCurrentPaymethod().indexOf('adyen') >= 0
    },
    isAlipay() {
      return this.getCurrentPaymethod().indexOf('alipay') >= 0
    },
    isXsolla() {
      return this.getCurrentPaymethod().indexOf('xsolla') >= 0
    },
    isGash() {
      return this.getCurrentPaymethod().indexOf('gash') >= 0
    },
    isGashLimitPayment() {
      return this.isGash() && (this.getCurrentPaymethod().indexOf('COPBTC01') >= 0 || this.getCurrentPaymethod().indexOf('COPNTC01') >= 0)
    },
    getCurrentPaymethod() {
      return this.gameInfo.payments[this.selObj.paymentIndex].payMethod || ''
    },
    handlerPayResult(d) {
      if (this.isAirwallex()) {
        var data = {
          methods: [this.getCurrentPaymethod().replace('airwallex--', '')]
        }
        console.error(222)
        if (this.getCurrentPaymethod().indexOf('applepay') >= 0) {
          data.applePayRequestOptions = {
            countryCode:'HK'
          }
        }
        this.toPayAirWallex(d, data)
        return
      }
      if (this.isAdyen()) {
        this.toAdyen(d)
        return
      }
      if (this.isXsolla()) {
        this.toXsolla(d)
        return
      }
      if (this.isGash()) {
        this.toGash(d)
        return
      }
      if (this.isAlipay()) {
        this.toAdyen(d)
        return
      }
    },
    toPayAirWallex(d, data) {
      this.hideLoading()
      this.closeConfirmDialog()
      var a = d.url.split('|||')
      payments.redirectToCheckout(Object.assign(
        {
        intent_id: a[0],
        client_secret: a[1],
        currency: 'JPY',
        successUrl: 'https://game.eternaldragoon.com/api/game/handleRedirect/airwallex?region=jpn&order_sn=' + d.order_sn,
        failUrl: 'https://game.eternaldragoon.com/api/game/handleRedirect/airwallex?region=jpn&order_sn=' + d.order_sn,
        // country_code: "US"
        // methods: ['card']
      }, data
      ));
    },
    async toAdyen(d) {
        this.closeConfirmDialog()
        window.open(d.url, '_blank');
    },
    async toXsolla(d) {
        this.closeConfirmDialog()
        window.open(d.url, '_blank');
    },
    toGash(d) {
      this.closeConfirmDialog()
      
      const form = document.createElement('form');
      form.method = 'POST';
      // form.action = 'https://stage-api.eg.gashplus.com/CP_Module/order.aspx';  // 目标地址
      form.action = 'https://api.eg.gashplus.com/CP_Module/order.aspx';  // 目标地址
      
      form.target = '_blank'; // 可选：是否在新窗口打开
      form.style.display = 'none';

      form.enctype = 'application/x-www-form-urlencoded';

      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = "data"
      input.value = d.url
      form.appendChild(input);

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },
    pay(item, index) {
      this.selProduct(item, index)
      if (!this.checkLogin()) return
      if (!this._getServer()) {
        this.tip('please sel Server')//請選擇服務器
        return
      }
      if (!this._getRole()) {
        this.tip('please sel role')//請選擇角色
        return
      }
      if (!this.getCurrentProduct()) {
        this.tip('please sel product')//請選擇儲值項
        return
      }

      this.openConfirmDialog()

    },
    callPay() {
      var payMethod = this.getCurrentPaymethod()
      var p = {
        app_id: this.gameInfo.appId,
        product_id: this.getCurrentProduct().productId,
        server_id: this._getServer().id + '',
        role_id: this._getRole().id + '',
        role_name: this._getRole().name,
        pay_method: payMethod
      }

      this.showLoading()
      api.pay(p).then(d => {
        this.hideLoading()
        this.handlerPayResult(d)
      }).catch(e => {
        this.hideLoading()
        this.tip(e)
      })
    },
    toUrl(url) {
        window.open(url, '_blank');
    },
    getProducts() {
      api.productsList({
        app_id: this.gameInfo.appId,
      }).then(d => {
        console.log('p-->', d)
        var zuanshiListTmp = d.list['1'] || []
        var zuanshiList = []
        var xianjinListTmp = d.list['2'] || []
        var xianjinList = []
        for(var i of zuanshiListTmp) {
          i.sel = false
          i.type = i.refer.type
          i.sub_type = i.refer.sub_type || 0
          i.productId = i.product_id
          i.price = i.refer.money
          i.rebate = i.refer.rebate
          i.diamond = i.refer.diamond
          i.b_diamond = i.refer.b_diamond
          i.icon = i.refer.icon
          i.show = i.refer.show || false
          if (i.show) zuanshiList.push(i)
        }
        
        for(var i of xianjinListTmp) {
          i.sel = false
          i.type = i.refer.type
          i.sub_type = i.refer.sub_type || 0
          i.productId = i.product_id
          i.price = i.refer.money
          i.rebate = i.refer.rebate
          i.voucher = i.refer.voucher
          i.b_diamond = i.refer.b_diamond
          i.bg = require('../assets/pay/xianjinquan-1.png')
          i.icon = i.refer.icon
          i.show = i.refer.show || false
          if (i.show) xianjinList.push(i)
        }
       this.zuanshiList = zuanshiList.sort((a, b) => a.price - b.price)
       for(var i of zuanshiList) {
          i.bg = require(`../assets/pay/zuanshi-bg-${zuanshiList.indexOf(i)}.png`)
        }

       this.xianjinList = xianjinList.sort((a, b) => a.price - b.price)
      }).catch(e => {
        this.tip(e)
      })
    },
    checkLogin() {
      if (!this.isLogined()) {
        this.showLoginAlert()
        return false
      }
      return true
    },
    toggleRoleView() {
      if (!this.checkLogin()) return
      this.showRoles = !this.showRoles
      this.showServers = false
    },
    toggleServerView() {
      if (!this.checkLogin()) return
      this.showServers = !this.showServers
      this.showRoles = false
    },
    changeServer(index) {
      this.showServers = false
      if (this.selObj.serverIndex == index) return
      this.selObj.serverIndex = index

      this.selObj.roleIndex = -1
      console.log('22')
      this.getRoles()
    },
    _getServer() {
      if (this.selObj.serverIndex == -1) {
        return null
      }
      return this.serverList[this.selObj.serverIndex]
    },
    getServers() {
      api.serverList({
        app_id: this.gameInfo.appId,
      }).then(d => {
        this.serverList = d || []
        if (this.serverList.length > 0) this.changeServer(0)
      }).catch(e => {
        console.error(e)
        this.serverList = []
      })
    },
    changeRole(index) {
      this.showRoles = false
      if (this.selObj.roleIndex == index) return
      this.selObj.roleIndex = index
    },
    _getRole() {
      if (this.selObj.roleIndex == -1) {
        return null
      }
      return this.roleList[this.selObj.roleIndex]
    },
    getRoles() {
      let server = this._getServer();
      server && api.roleList({
        app_id: this.gameInfo.appId,
        server_id: server.id + '',
      }).then(d => {
        this.roleList = d || []
        if (this.roleList.length > 0) this.changeRole(0)
      }).catch(e => {
        console.error(e)
        this.roleList = []
      })
    },
    changeGame(index) {
      if (this.selObj.gameIndex == index) return
      this.selObj.gameIndex = index

      this.setGameInfo(this._getGame())

      this.changeServer(-1)
      this.serverList = []
      this.changeRole(-1)
      this.roleList = []

      this.selObj.productIndex = -1
      this.getServers()
      this.getProducts()
    },
    _getGame() {
      if (this.selObj.gameIndex == -1) {
        return null
      }
      return this.games[this.selObj.gameIndex]
    },

    selGame(index, isInit) {
      if (this.selGameIndex == index) return
      this.selGameIndex = index
      this.setGameInfo(this.games[index])

      if (isInit) return
    },
    showLoginAlert() {
      this.showLoginDialog = true
      this.$nextTick(() => {
          this.thirdLogin.google && this.createdGoogleLogin(this.getGoogleConfigId())
          if (this.thirdLogin.apple) {
            this.appleLogin(this.getAppleConfig());
          }
          if (this.thirdLogin.fb) {
             FB.init({
              appId: this.getFbConfigId(),
              autoLogAppEvents: true,
              xfbml: true,
              version: 'v20.0'
            });
          }
      });
    },
    initThird() {
      const google = document.createElement('script');
      google.type = 'text/javascript';
      google.src = 'https://accounts.google.com/gsi/client';
      google.onload = () => {
        this.thirdLogin.google = true
      }
      // google.async = true
      document.body.appendChild(google);


      const fb = document.createElement('script');
      fb.type = 'text/javascript';
      fb.src = 'https://connect.facebook.net/en_US/sdk.js';
      fb.async = true
      fb.defer = true
      fb.crossOrigin = 'anonymous'
      fb.onload = () => {
        FB.init({
          appId: this.getFbConfigId(),
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v20.0'
        });
        this.thirdLogin.fb = true
      }
      document.body.appendChild(fb);

      const ap = document.createElement('script');
      ap.type = 'text/javascript';
      ap.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
      ap.onload = () => {
        this.appleLogin(this.getAppleConfig());
        this.thirdLogin.apple = true
      }
      document.body.appendChild(ap);
    },
    getAppId() {
      return this._getGame().appId
    },
    getAppleConfig() {
      return this.gameInfo.apple
    },
    getFbConfigId() {
      return this.gameInfo.facebook.appId
    },
    getGoogleConfigId() {
      return this.gameInfo.google.clientId
    },
    isLogined() {
      return this.userInfo.token.length > 0
    },
    createdGoogleLogin(googleClientId) {
      if (!google)return
      google.accounts.id.initialize({
        client_id: googleClientId,
        callback: this.handleCredentialResponse
      });
      google.accounts.id.renderButton(
        document.getElementById("gg"),
        { theme: "outline", size: "large" }  // customization attributes
      );
      document.getElementById("gg").style.display = "none";  
    },
    googleLogin() {
      google && google.accounts.id.prompt();
    },
    handleCredentialResponse(r) {
      console.log("123")
      api.googleLogin({
        app_id: this.getAppId(),
        id_token: r.credential
      }).then(d => {
        this.loginLocal(d)
        this.resetGameInfo()
      }).catch(e => {
        console.error(e)
        tip(e)
      })
    },
    appleLogin(config) {
      if (!AppleID)return
      AppleID.auth.init(Object.assign({
        scope: "name email", // To tell apple we want the user name and emails fields in the response it sends us.
        state: "origin:web", // Any string of your choice that you may use for some logic. It's optional and you may omit it.
        usePopup: false, // Important if we want to capture the data apple sends on the client side.
      }, config));
    },
    tip(s) {
      alert(s)
    },
    fbLogin() {
      FB && FB.getLoginStatus(response => {
        if (!response.session) {
          this.fb2login()
          return
        }

        FB.logout(r => {
          this.fb2login()
        })
      })
    },
    fb2login() {
      FB.login(r => {
        console.error('fb登录结果：', r)
        if (r.status === 'connected') {
          console.error('登录成功')
          api.facebookLogin({
            app_id: this.getAppId(),
            id_token: r.authResponse && r.authResponse.accessToken || ''
          }).then(d => {
            this.loginLocal(d)
            this.resetGameInfo()
          }).catch(e => {
            console.error(e)
            this.tip(e)
          })
        } else {
          this.tip('fail')
        }
      })
    },
    login() {
      if (!this.loginAccount) {
        this.showError('id');
        return;
      }
      if (!this.loginPassword) {
        this.showError('pwd');
        return;
      }
      if (!this.loginAgree) {
        this.showError('fail');
        return;
      }
      if (this.isLogining) return
      this.isLogining = true

      let param = {
        app_id: this.getAppId(),
        account: this.loginAccount,
        password: this.loginPassword,
        device_id: ''
      }
      api.login(param).then(d => {
        this.tip('ログイン成功！')
        this.loginLocal(d)
        this.resetGameInfo()
      }).catch(e => {
        console.error(e)
        this.isLogining = false
        this.tip(e.msg || e || 'unknow err')
      })

    },
    resetGameInfo() {
      this.changeServer(-1)
      this.changeRole(-1)
      this.roleList = []
      this.isLogining = false
      this.showLoginDialog = false;
    },
    tokenTryLogin(token, appId, success, fail) {
      api.tokenLogin({
        token: token,
        app_id: appId
      }).then(d => {
        if (success) success(d)
      }).catch(e => {
        if (fail) fail(e)
        // this.$router.replace('/account')  
      })
    },
    tokenLoginSuccess(d, token) {
        d.token = token
        this.loginLocal(d)
        this.resetGameInfo()
    }
  },
  mounted() {
    this.bannerInterval = setInterval(this.nextBanner, 3000);
    window.addEventListener('wheel', this.preventZoom, { passive: false });

    for (let game of this.games) {
      if (game.id == this.gameInfo.id && game.appId == this.gameInfo.appId) {
        this.changeGame(this.games.indexOf(game))
      }
    }

    this.initThird()
  },
  created() {
    if (window.innerWidth < 1000) document.documentElement.style.fontSize = '8px'

    try {
      this.isSDK = typeof xmsdk != 'undefined';
    } catch (e) {

    }

    // this.showLoading()

    let token = this.$route.query.token || ''
    console.error('+++++++++++', token)
    let appId = this.$route.query.app_id || ''
    if (token && token.length > 0) {
      this.showLoading()
      //兼容appid没传的问题
      let app = Number(appId)
      if (app != 0) {
        this.tokenTryLogin(token, app, d => {
          this.hideLoading()
          this.tokenLoginSuccess(d, token)
        }, e => {
          this.hideLoading()
          this.tip(e.msg || '')
        })
        return
      }

      //appid没传 挨个尝试
      this.tokenTryLogin(token, 10060, d => {
        this.hideLoading()
          this.tokenLoginSuccess(d, token)
      }, e => {
        this.tokenTryLogin(token, 10061, d => {
          this.hideLoading()
          this.tokenLoginSuccess(d, token)
        }, e => {
          this.tokenTryLogin(token, 10063, d => {
            this.hideLoading()
          this.tokenLoginSuccess(d, token)
          }, e => {
            this.hideLoading()
            this.tip(e.msg || '')
          })
        })
      })
      return
    }
  },
  beforeDestroy() {
    clearInterval(this.bannerInterval);
    document.removeEventListener('click', this.handleOutsideClick);
    window.removeEventListener('wheel', this.preventZoom);
  }
}
